module.exports = __webpack_public_path__ + "static/media/arrow-down.facfef10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-down.svg
// module id = 852
// module chunks = 0